export default __webpack_public_path__ + "5fad7117107a70a5d91a8221e00e9dd5.gif";